export default {
  marginDense: {
    marginTop: 0,
    marginBottom: 3,
  },
};
